let app = {
	setState: null,
	state: {},
}

export default app;